import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=faff6b1c&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=faff6b1c&prod&scoped=true&lang=scss"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=faff6b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faff6b1c",
  null
  
)

export default component.exports